export default {
  data() {
    return {
      Price:'',
      showPrice:"",
      showPriceText:"",
      url:{
        // GetPagingProductInfoForWebUrl:SZH.assets.api + '/Product/GetPagingProductInfoForWeb ',//列表
        GetPagingProductInfoForWebUrl:SZH.assets.api + '/Product/GetPagingProductInfoForWeb2',//列表 2021/10/21 更改 未挂牌不显示
        GetCustomAuthType:SZH.assets.api + '/Custom/GetCustomAuthType2',//是否进行过认证 2021/12/24 更改
        GetSystemConfigure:SZH.assets.api + '/Market/GetSystemConfigure',//价格 2021/12/24 更改
      },
      form:{
        Keyword:'',
        WareHouseId:'',
        MaterielTypeId:'',
        MaterielId:'',
        BusinessType:'',
        PriceSortType:'desc',//asc升序
      },
      productList:[],
      fullscreenLoading:false
    }
  },
  methods: {
    GetCustomAuthType(){
      let self = this
      self.$http.post(self.url.GetCustomAuthType,{}).then(result=>{
        if(result.state == 1){
          self.Price = result.data
          if(result.data != 1){
            self.GetSystemConfigure("AuthCompanyPrice")
          }
        }
      })
    },
    GetSystemConfigure(val){
      let self = this
      self.$http.post(self.url.GetSystemConfigure,{
        keyValue:val
      }).then(result=>{
        if(result.state == 1){
          if(val == "AuthCompanyPrice"){
            self.showPrice = result.data
            if(result.data != "True"){
              self.GetSystemConfigure("PriceText")
            }
          }
          if(val == "PriceText"){
            self.showPriceText = result.data
          }
        }
      })
    },
    toBuy(pro){
      let self = this
      if(self.showPrice == "False"){
        return
      }
      if(pro.Price != 0){
        if(pro.BusinessType == 3) {
          self.turnTo('/Menu/detail2', pro);
        }
        else {
          self.turnTo('/Menu/detail', pro);
        }
      }else{
        self.$message.error('产品已售空');
      }
    },
    turnTo(url, pro) {
      if(pro) {
        this.$router.push({
          path: url,
          query:{ id: pro.ProductId, w: pro.WarehouseId}
        })
      }
      else {
        this.$router.push({
          path: url
        })
      }
    },
    getPic(item){
      if(item.PictureUrl){
        return SZH.assets.image +'/'+ item.PictureUrl;
      }else{
        return ''
      }
    },

    GetPagingProductInfoForWebFun(){

      let self = this;
      self.fullscreenLoading = true;
      self.$http.post(self.url.GetPagingProductInfoForWebUrl,  {
        Data:{},
        PageIndex: 1,
        PageSize: 9,
      })
        .then(result => {
          if (result.state == true) {
            self.productList = result.data.Data;
            self.TotalCount = result.data.TotalCount
          } else {
            self.productList = [];
            self.TotalCount = 0;
          }
          self.fullscreenLoading = false;
        }, () => {
          // 请求失败
          self.$message.error('查询失败，请检查您的网络是否可用。');
          self.fullscreenLoading = false;
        });
    },
  },
  computed: {},
  components: {},
  mounted(){
    this.GetPagingProductInfoForWebFun();
    this.GetCustomAuthType();
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeChare/HomeChare.js